import { createAsyncThunk } from '@reduxjs/toolkit';

import generateLogger from '@travel/logger';

import { getDomBonusProgramAPI, getDomCouponAPI } from './api';

import type { ApiClient } from '@travel/api-client';
import type {
  BonusProgramResponse,
  CouponParams,
  CouponResponse,
  ThunkErrorPayload,
} from '@travel/traveler-core/store/dom-coupon/types';

const logger = generateLogger();

type ThunkExtra = {
  apiClient: ApiClient;
  history?: any;
  req?: any;
  res?: any;
};

// Extended params with providerId (hotel number)
export type FetchDomCouponParams = CouponParams & {
  providerId: number;
};

// Async thunk for fetching coupon data
export const fetchDomCoupon = createAsyncThunk<
  CouponResponse,
  FetchDomCouponParams,
  { extra: ThunkExtra; rejectValue: any }
>('domCoupon/fetch', async (params, { extra, rejectWithValue }) => {
  const { apiClient } = extra;
  const { providerId, ...couponParams } = params;

  try {
    const response = await getDomCouponAPI(apiClient, couponParams);
    return response;
  } catch (error: any) {
    logger.error(`Fetch Coupon Error for provider ${providerId}`, error);
    return rejectWithValue({
      message: error?.message ?? String(error),
      name: error?.name,
      status: error?.status,
    });
  }
});

// Async thunk for fetching bonus program data
export const fetchDomBonusProgram = createAsyncThunk<
  BonusProgramResponse,
  void,
  { extra: ThunkExtra; rejectValue: ThunkErrorPayload }
>('domBonusProgram/fetch', async (_params, { extra, rejectWithValue }) => {
  const { apiClient } = extra;

  try {
    const response = await getDomBonusProgramAPI(apiClient);
    return response;
  } catch (error: unknown) {
    const err = error instanceof Error ? error : new Error(String(error));
    logger.error(`Fetch BonusProgram Error`, err);
    return rejectWithValue({
      message: err.message,
      name: err.name,
      status: (error as { status?: number })?.status,
    });
  }
});
